import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { AnchorButton, Button, Heading, Sizes, Spacings, } from '@polestar/component-warehouse-react/index';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
export const HeroSectionCommonButtonGroup = forwardRef(({ buttonOne, buttonTwo, isResponsive = false }, ref) => {
    let ButtonOne;
    let ButtonTwo;
    if (buttonOne && 'href' in buttonOne) {
        ButtonOne = AnchorButton;
    }
    else {
        ButtonOne = Button;
    }
    if (buttonTwo && 'href' in buttonTwo) {
        ButtonTwo = AnchorButton;
    }
    else {
        ButtonTwo = Button;
    }
    return (React.createElement(ButtonGroup, { ref: ref, isResponsive: isResponsive },
        buttonOne && React.createElement(ButtonOne, { ...buttonOne }),
        buttonTwo && React.createElement(ButtonTwo, { ...buttonTwo })));
});
export const HeroSectionCommonTitleGroup = forwardRef(({ title, tagline }, ref) => {
    return (React.createElement(TitleGroup, { ref: ref },
        React.createElement(Title, { size: Sizes.medium, level: 1, isMultiline: true }, title),
        React.createElement(Tagline, { size: Sizes.medium, level: 2, isMultiline: true }, tagline)));
});
/**
 * Controls the content column for visual and split hero sections.
 */
export const contentGridCols = (isBleed) => isBleed
    ? {
        mobile: 4,
        tablet: 5,
        desktop: 5,
        desktopWide: 4,
    }
    : {
        mobile: 4,
        tablet: 5,
        desktop: 5,
        desktopWide: 5,
    };
const ButtonGroup = styled('div', shouldNotForwardProps(true, 'isResponsive'))(({ isResponsive }) => {
    return css(css `
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: ${Spacings.medium};
      flex-wrap: wrap;
    `, isResponsive &&
        css `
        ${responsiveStyles({
            flexDirection: {
                mobile: 'column',
                tablet: 'row',
            },
        })};
      `);
});
const TitleGroup = styled.div(css `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`);
const Title = styled(Heading)(({ theme }) => css `
    color: ${theme.heroSection.titleColor};
  `);
const Tagline = styled(Heading)(({ theme }) => css `
    color: ${theme.heroSection.tagColor};
  `);
